import LegalLayout from "@/components/LegalLayout";

export default function Datenschutz() {
    return (
        <LegalLayout title="Datenschutzerklärung" eyebrow="Information nach Art. 13 DSGVO">
            <section>
                <h2>1. Verantwortliche Stelle</h2>
                <p>
                    Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO):
                </p>
                <p>
                    Stickerbag, Isabell Helmund<br />
                    In der Straße der Jugend 18<br />
                    14974 Ludwigsfelde<br />
                    E-Mail: <a href="mailto:lunarislp@gmx.de">lunarislp@gmx.de</a><br />
                    Telefon: +49 176 82337092
                </p>
            </section>

            <section>
                <h2>2. Allgemeine Hinweise</h2>
                <p>
                    Wir behandeln deine personenbezogenen Daten vertraulich und entsprechend
                    den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutz­erklärung.
                </p>
            </section>

            <section>
                <h2>3. Server-Logfiles</h2>
                <p>
                    Beim Aufruf dieser Website werden durch den Browser automatisch
                    Informationen an unseren Server übermittelt (Datum/Uhrzeit, aufgerufene
                    URL, HTTP-Status, übertragene Datenmenge, anonymisierte IP, Browsertyp).
                    Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO. Speicherung max. 14 Tage.
                </p>
            </section>

            <section>
                <h2>4. Gedenkseiten im Taubenhimmel</h2>
                <p>
                    Wenn du eine Gedenkseite anlegst, speichern wir die von dir eingegebenen
                    Daten (Name der Taube, Geschichte, optionale Daten/Ort/Nachricht/Name
                    der Person, Bild). Diese Inhalte sind <strong>öffentlich sichtbar</strong>.
                    Bitte gib keine Inhalte ein, deren Veröffentlichung du nicht möchtest.
                </p>
                <p>
                    Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
                </p>
            </section>

            <section>
                <h2>5. Himmelsfond-Anträge</h2>
                <p>
                    Antragsdaten (Beschreibung, Fotos, Rechnungen, Kontaktdaten) verarbeiten
                    wir ausschließlich zur Prüfung und Bearbeitung deines Antrags und zur
                    Kommunikation mit dir. Kontaktdaten und Belege sind nicht öffentlich.
                </p>
                <p>
                    Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO sowie Art. 6 Abs. 1 lit. a
                    DSGVO (Einwilligung im Formular).
                </p>
            </section>

            <section>
                <h2>6. Taubenvermittlung — Kontaktformular</h2>
                <p>
                    Wenn du eine Anfrage zu einer vermittelten Taube stellst, übermitteln
                    wir deine Nachricht (Name, E-Mail, optional Telefon, Inhalt) an die für
                    den Eintrag zuständige Pflegestelle. Wir speichern die Anfrage zur
                    Nachvollziehbarkeit.
                </p>
            </section>

            <section>
                <h2>7. Zahlung — Stripe / PayPal / Klarna</h2>
                <p>
                    Für Eintrags-Codes (2 €) und Spenden in den Himmelsfond nutzen wir die
                    Zahlungsdienstleister <strong>Stripe Payments Europe Ltd.</strong> (1 Grand Canal
                    Street Lower, Grand Canal Dock, Dublin, Irland) sowie über Stripe ggf.
                    <strong> PayPal (Europe) S.à r.l. et Cie, S.C.A.</strong> (22-24 Boulevard
                    Royal, 2449 Luxembourg) und <strong>Klarna Bank AB</strong> (Sveavägen 46,
                    111 34 Stockholm, Schweden). Bei der Bezahlung werden Daten (Name, E-Mail,
                    Betrag, Zahlungsmittel-Daten) direkt an den jeweiligen Anbieter übertragen.
                    Es gelten deren Datenschutzerklärungen.
                </p>
            </section>

            <section>
                <h2>8. Hosting &amp; Datenbank</h2>
                <p>
                    Diese Website wird auf Servern eines DSGVO-konformen Hosters mit Serverstandort
                    innerhalb der Europäischen Union betrieben. Inhaltsdaten (Gedenkseiten, Vermittlungs-Inserate,
                    Fonds-Anträge, Gästebuch-Einträge etc.) werden in einer von <strong>MongoDB, Inc.</strong>
                    (1633 Broadway, 38th Floor, New York, NY 10019, USA) bereitgestellten
                    Datenbank gespeichert. Der konkrete Cluster liegt im Rechenzentrum
                    <strong> Frankfurt (eu-central-1)</strong> innerhalb der EU.
                    Mit den eingesetzten Auftragsverarbeitern bestehen Auftragsverarbeitungsverträge
                    nach Art. 28 DSGVO.
                </p>
                <p>
                    Für den Versand transaktionaler E-Mails (z. B. Magic-Links zum Bearbeiten
                    eigener Einträge) nutzen wir <strong>Resend, Inc.</strong> (2261 Market Street #4942,
                    San Francisco, CA 94114, USA). Versendet werden nur die für die Zustellung
                    nötigen Daten (E-Mail-Adresse, Nachricht). Resend ist nach EU-US Data Privacy
                    Framework zertifiziert.
                </p>
            </section>

            <section>
                <h2>9. Cookies</h2>
                <p>
                    Wir setzen <strong>keine Tracking-Cookies und kein Analyse-Tracking</strong> ein.
                    Notwendige Funktionscookies (z. B. Admin-Login per Sitzungs-Cookie)
                    werden auf Basis von Art. 6 Abs. 1 lit. f DSGVO eingesetzt.
                </p>
            </section>

            <section>
                <h2>10. Deine Rechte</h2>
                <p>
                    Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17),
                    Einschränkung (Art. 18), Datenübertragbarkeit (Art. 20), Widerspruch
                    (Art. 21), Widerruf erteilter Einwilligungen (Art. 7 Abs. 3). Beschwerde
                    bei einer Aufsichtsbehörde.
                </p>
                <p>
                    Kontakt für alle Rechte: <a href="mailto:lunarislp@gmx.de">lunarislp@gmx.de</a>
                </p>
            </section>

            <p className="text-xs text-[#64748b] pt-8 border-t border-white/10">
                Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
            </p>
        </LegalLayout>
    );
}
